/*
 * Kadenze.RequestGuard
 *
 * Utility to guard against end-user page navigation while saving is in progress in the background
 *
 *      new Kadenze.RequestGuard().init();
 *
 */
export default function() {
  var self = this;

  self.enableBeforeUnload = function() {
    window.onbeforeunload = function (e) {
      return Kadenze.I18n.t('notice.request_guard_warning');
    };
  };

  self.disableBeforeUnload = function() {
    window.onbeforeunload = null;
  };

  self.init = function() {
    var observedRequests = ['POST','PUT','PATCH','DELETE'];
    self.xhrPool = ko.observableArray();
    self.xhrPool.subscribe(function(changes) {
      if (self.xhrPool().length > 0) {
        self.enableBeforeUnload();
      } else {
        self.disableBeforeUnload();
      }
    });

    $(document).ajaxSend(function(e, jqXHR, options){
      if ($.inArray(options.type, observedRequests) > -1)
        self.xhrPool.push(jqXHR);
    });

    $(document).ajaxComplete(function(e, jqXHR, options) {
      if ($.inArray(options.type, observedRequests) > -1) {
        var i = self.xhrPool.indexOf(jqXHR);
        if (i > -1) self.xhrPool.splice(i, 1);
      }
    });
  };

  const __construct = function(that) {
    console.log('constructor called for RequestGuard');
  }(this);
}
